import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'

import { WorkOrderItem } from '../WorkOrderItem'

@InputType()
export class CheckAllItemAvailabilityArgs extends ActionArgs {
  @Field(() => [WorkOrderItem])
  items: WorkOrderItem[]
}
